import { Injectable } from '@angular/core';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  public menuAdmin:any[];
  public menuClient:any[];
  public menuEvaluated:any[];
  public testsMenu:any[];
  public userRole;
  constructor() { 

    this.testsMenu = [
      {
        title:"16 Pf",
        icon:"fa fa-check-square-o",
        options:[

          {
            title:"Editor de textos",
            link:"pfTexts"
          },
          {
            title:"Crear pregunta",
            link:"createPf16"
          },
          {
            title:"Editar preguntas",
            link:"editPf16"
          },
          {
            title:"Crear factor ",
            link:"createPf16Factor"
          },
          {
            title:"Ver/editar factores ",
            link:"pf16Factor"
          },
          
          
        ]
      },
      {
        title:"Zavic",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Editor de textos",
            link:"zavicTexts"
          },
          {
            title:"Crear pregunta",
            link:"createZavic"
          },
          {
            title:"Editar preguntas",
            link:"editZavic"
          },
          {
            title:"Crear valor",
            link:"createZavicFactor"
          },
          {
            title:"Ver/editar valores",
            link:"viewZavicFactor"
          },

          
          
        ]
      },
      {
        title:"IPV",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Editor de textos",
            link:"ipvTexts"
          },
          {
            title:"Crear pregunta",
            link:"createIpv"
          },
          {
            title:"Editar preguntas",
            link:"editIpv"
          },
          {
            title:"Crear valor",
            link:"createIpvFactor"
          },
          {
            title:"Ver/editar valores",
            link:"viewIpvFactor"
          },
        ]
      },
      {
        title:"AllPort",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Editor de textos",
            link:"allPortTexts"
          },
          {
            title:"Crear pregunta",
            link:"createAllPort"
          },
          {
            title:"Editar preguntas",
            link:"viewAllPort"
          },
          {
            title:"Crear factor",
            link:"createAllPortFactor"
          },
          {
            title:"Borrar factores",
            link:"viewAllPortFactor"
          },
        ]
      },
      {
        title:"Barsit",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Editor de textos",
            link:"barsitTexts"
          },
          {
            title:"Crear pregunta",
            link:"createBarsit"
          },
          {
            title:"Editar",
            link:"viewBarsit"
          },
          {
            title:"Crear factor",
            link:"createBarsitFactor"
          },
          {
            title:"Ver/editar factores",
            link:"viewBarsitFactor"
          },
        ]
      },
      {
        title:"Cleaver",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Editor de textos",
            link:"cleaverTexts"
          },
          {
            title:"Catálogo de Personalidad",
            link:"humanFactorTexts"
          },
          {
            title:"Crear pregunta Cleaver",
            link:"createCleaver"
          },
          {
            title:"Editar Cleaver",
            link:"viewCleaver"
          },
          {
            title:"Crear factor Cleaver",
            link:"createCleaverFactor"
          },
          {
            title:"Ver factores Cleaver",
            link:"viewCleaverFactor"
          },
        ]
      },
      {
        title:"Terman",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Editor de textos",
            link:"termanTexts"
          },
          {
            title:"Crear pregunta",
            link:"createTerman"
          },
          {
            title:"Editar preguntas",
            link:"viewTerman"
          },
          {
            title:"Crear factor",
            link:"createTermanFactor"
          },
          {
            title:"Ver/editar factores",
            link:"viewTermanFactor"
          },
        ]
      },
      {
        title:"Kostick",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Editor de textos",
            link:"kostikTexts"
          },
          {
            title:"Crear pregunta",
            link:"createKostik"
          },
          {
            title:"Editar preguntas",
            link:"viewKostik"
          },
          {
            title:"Crear factor",
            link:"createKostikFactor"
          },
          {
            title:"Ver/editar factores",
            link:"viewKostikFactor"
          },
        ]
      },
      {
        title:"MMPI-2",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Crear/editar escalas",
            link:"createMmpi2Factor"
          },
          {
            title:"Interpretación de escalas",
            link:"mmpi2Interpretations"
          },          
          {
            title:"Preguntas",
            link:"mmpi2Questions"
          },
          {
            title:"Textos",
            link:"mmpi2Texts"
          },
          {
            title:"Combinaciones de códigos",
            link:"mmpi2Combinations"
          },
        ]
      },
      {
        title:"MMPI-A",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Crear/editar escalas",
            link:"createMmpiaFactor"
          },
          {
            title:"Interpretación de escalas",
            link:"mmpiaInterpretations"
          },          
          {
            title:"Preguntas",
            link:"mmpiaQuestions"
          },
          {
            title:"Textos",
            link:"mmpiaTexts"
          },
          {
            title:"Combinaciones de códigos",
            link:"mmpiaCombinations"
          },
        ]
      },
      {
        title:"MIPS",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Crear/editar escalas",
            link:"mipsScales"
          },
          {
            title:"Interpretación de escalas",
            link:"mipsInterpretations"
          },          
          {
            title:"Preguntas",
            link:"mipsQuestions"
          },
          {
            title:"Textos",
            link:"mipsTexts"
          },
        ]
      },
      {
        title:"BIS-11",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Interpretación de escalas",
            link:"bis11Interpretations"
          },          
          {
            title:"Preguntas",
            link:"bis11Questions"
          },
          {
            title:"Textos",
            link:"bis11Texts"
          },
        ]
      },
      {
        title:"Chaside",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Interpretación de escalas",
            link:"chasideInterpretations"
          },          
          {
            title:"Preguntas",
            link:"chasideQuestions"
          },
          {
            title:"Textos",
            link:"chasideTexts"
          },
        ]
      },
      {
        title:"Domino",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Textos",
            link:"dominoTexts"
          },
          {
            title:"Interpretaciones",
            link:"dominoInterpretations"
          },
        ]
      }
    ]
   
    this.menuAdmin = [
      {
        title:"Administrador",
        icon:"fa fa-user-circle",
        options:[
          {
            title:"Crear usuario",
            link:"createUser"
          },
          {
            title:"Usuarios registrados",
            link:"users"
          },
          {
            title:"Editar Planes",
            link:"editPlans"
          },
          {
            title:"Modo de uso editor",
            link:"texts"
          },
          {
            title:"Texto de emails",
            link:"emailTexts"
          },
          {
            title:"Información de pruebas",
            link:"testInfo"
          },
          
        ]
      },
      
      {
        title:"Evaluaciones",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Ver pruebas",
            link:"custom-tests"
          },
          {
            title:"Crear prueba",
            link:"create-custom-test"
          },
          {
            title:"Grupos de pruebas",
            link:"test-groups"
          },
          {
            title:"Crear nuevo grupo",
            link:"create-test-group"
          },
        ]
      },
      {
        title:"Pagos",
        icon:"fa fa-money",
        options:[
          {
            title:"Historial de pagos",
            link:"payments"
          },
        ]
      },

    
    ]

    this.menuClient = [

      {
        title:"Evaluados",
        icon:"fa fa-user-circle",
        options:[
          {
            title:"Asignar pruebas",
            link:"createEvaluated"
          },
          {
            title:"Ver evaluados",
            link:"clientEvaluated"
          },
          
        ]
      },
      {
        title:"Formularios (KQ)",
        icon:"fa fa-user-circle",
        options:[
          {
            title:"Ver informes",
            link:"clientEvaluated",
            query: {action: 'massive'}
          },
          {
            title:"Crear formularios",
            link:"forms"
          },
          
        ]
      },
      

      

    ]

    this.menuEvaluated = [

      {
        title:"Mis Pruebas",
        icon:"fa fa-check-square-o",
        options:[
          {
            title:"Pruebas",
            link:"requestedTests"
          },
          
        ]
      },

    
    ]

  }

  getMenu(type:string){
    if (type === "admin") return this.menuAdmin;
    if (type === "client") return this.menuClient;
    if (type === "evaluated") return this.menuEvaluated;
  }

  getAdminTests(){
    return this.testsMenu;
  }

}
